/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./roomChange.vue?vue&type=template&id=0f2671b3&scoped=true&"
import script from "./roomChange.vue?vue&type=script&lang=js&"
export * from "./roomChange.vue?vue&type=script&lang=js&"
import style0 from "./roomChange.vue?vue&type=style&index=0&id=0f2671b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2671b3",
  null
  
)

export default component.exports